import { SpecialIndex } from './Types'

export function isSpecialIndex(input: number | SpecialIndex): input is SpecialIndex {
  return input === SpecialIndex.First || input === SpecialIndex.Last
}
